import { ADJUSTER_REPORT_CULPRIT_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import CulpritCroquisPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/croquis/CulpritCroquisPage';
import CustomerAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/customerImages/CustomerAttachedImages';
import CustomerDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/customerImages/CustomerDocumentsImages';
import CustomerImagesTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/customerImages/CustomerImagesTabs';
import VehicleImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/customerImages/VehicleImages';
import { Outlet, RouteObject } from 'react-router-dom';

import CulpritAdjusterAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/AccidentAttachments/CulpritAdjusterAttachedImages';
import CulpritAdjusterImagesTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/CulpritAdjusterImagesTabs';

import CulpritImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/images/culpritImageFlow';
import ShowCulpritAdjusterAttachedImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/AccidentAttachments/ShowCulpritAdjusterAttachedImages';
import FlowCulpritGuidePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/flowGuide/FlowCulpritGuidePage';
import CulpritDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/vehicleImages/damagedPoints/CulpritDamagedPoints';
import CulpritServerDamagedPointsPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/vehicleImages/damagedPoints/CulpritImagePreviewDamagedPoints';
import VehicleCulpritImagePreviewPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/vehicleImages/vehicleCulpritImagePreview/vehicleCulpritImagePreview';
import VehicleCulpritServerImagePreviewPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/vehicleImages/vehicleCulpritImagePreview/vehicleCulpritServerImagePreview';
import VehicleCulpritShowServerImagePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/adjusterImages/vehicleImages/vehicleCulpritImagePreview/vehicleCulpritShowServerImage';
import CulpritCorrectiveImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/correctiveImages/CulpritCorrectiveImages';
import ShowCulpritCroquisPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/croquis/ShowCulpritCroquisPage';
import CulpritImagesTabPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/culpritImagesTab/CulpritImagesTabPage';
import CulpritSignaturePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/culprit/propertyDamage/images/signature/CulpritSignaturePage';
import AdjusterDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/AdjusterDocumentsImages';
import ShowAdjusterDocumentImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/ShowAdjusterDocumentImages';

const CUSTOMER_IMAGES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.base,
    children: [
      {
        index: true,
        element: <CustomerImagesTabs />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.vehicleImages,
        element: <VehicleImages />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.document,
        element: <CustomerDocumentsImages />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.additional,
        element: <CustomerAttachedImages />,
      },
    ],
  },
];
const VEHICLE_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.base,
    element: <Outlet />,
    children: [
      {
        element: <CulpritAdjusterImagesTabs />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .damagedPoints,
        element: <CulpritDamagedPoints />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .previewImageDamagePoint,
        element: <CulpritServerDamagedPointsPage />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .takePhotoGuide,
        element: <FlowCulpritGuidePage />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .takePhotoFlow,
        element: <CulpritImageFlow />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .PreviewImages,
        element: <VehicleCulpritImagePreviewPage />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .editablePreviewImages,
        element: <VehicleCulpritServerImagePreviewPage />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE
          .showPreviewImages,
        element: <VehicleCulpritShowServerImagePage />,
      },
    ],
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.DOCUMENT.show,
    element: <ShowAdjusterDocumentImages userType="culprit" />,
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.DOCUMENT.edit,
    element: <AdjusterDocumentsImages userType="culprit" />,
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.ADDITIONAL.edit,
    element: <CulpritAdjusterAttachedImages />,
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.ADDITIONAL.show,
    element: <ShowCulpritAdjusterAttachedImages />,
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.CROQUIS.edit,
    element: <CulpritCroquisPage />,
  },
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.CROQUIS.show,
    element: <ShowCulpritCroquisPage />,
  },
];
const ADJUSTER_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.base,
    element: <Outlet />,
    children: VEHICLE_IMAGES_ROUTES,
  },
];
export const ADJUSTER_REPORT_CULPRIT_IMAGES_ROUTES: RouteObject[] = [
  {
    children: [
      { index: true, element: <CulpritImagesTabPage /> },
      ...ADJUSTER_IMAGES_ROUTES,
      ...CUSTOMER_IMAGES,
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.SIGNATURE.edit,
        element: <CulpritSignaturePage editable />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.SIGNATURE.show,
        element: <CulpritSignaturePage editable={false} />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.corrective,
        element: <CulpritCorrectiveImages />,
      },
    ],
  },
];
